import apiVersion1 from "./v1";
// (hint): an example: import apiVersion2 from "./v2";
import apiUnversioned from "./unversioned";
import type { IResponse } from "./Types.ts";

const defaultApi = { apiVersion1, apiUnversioned };

export { apiVersion1, defaultApi, IResponse };
